import _ from 'lodash';
import { Fetch } from 'barnyard/utils/';
import * as constants from '../constants';
import { addNotification } from '~/app/common/packages/notifications';


/** *
The fetch to corporate user returns the corporate,
the profile, and the corporate user
***/
export const corporateUserFetch = () => (dispatch, getState) => Fetch({
  url: '/api/corporates/corporateuser/',
  success: (json) => {
    dispatch({
      type: constants.CORPORATE_FETCH_SUCCESS,
      entity: json.corporate
    });
    dispatch({
      type: constants.CORPORATE_DATA_SETTINGS_FETCH.success,
      entity: json.corporate_data_settings
    });
    dispatch({
      type: constants.BUYERS_FETCH_SUCCESS,
      entities: _.keyBy(json.corporate.buyers, 'id')
    });
    dispatch({
      type: constants.CORPORATE_REGIONS_FETCH_SUCCESS,
      entities: _.keyBy(json.corporate.corporate_regions, 'id')
    });
    dispatch({
      type: constants.CORPORATE_USER_FETCH_SUCCESS,
      entity: _.omit(json, ['corporate', 'user'])
    });
    dispatch({
      type: constants.PROFILE_FETCH_SUCCESS,
      entity: json.user
    });
  }
});

export const corporateUserUpdate = ({ form, success_notification = false, successAction = false } = {}) => {
  return (dispatch, getState) => Fetch({
    url: '/api/corporates/corporateuser/',
    method: 'PATCH',
    body: form,
    before: () => {
      dispatch({
        type: constants.CORPORATE_USER_UPDATE.request
      });
    },
    success: (json) => {
      dispatch({
        type: constants.RESET_DATA
      });
      dispatch({
        type: constants.CORPORATE_USER_UPDATE.success,
        entity: json
      });
      if (success_notification) {
        dispatch(
          addNotification({
            value: 'Corporate Region Updated!'
          })
        );
      }
      if (successAction) {
        dispatch(successAction());
      }
    },
    failure: (error) => {
      if (success_notification) {
        dispatch(
          addNotification({
            value: 'Error updating corporate profile',
            is_error: true
          })
        );
      }
      dispatch({
        type: constants.CORPORATE_USER_UPDATE.failure,
      });
    }
  });
};
